import { getParam } from '../utils/marketingHelper';

const REFERRAL_SOURCE_VALUE = 'friends';

export class ReferralService {
  private static getReferrerIdFromSearchParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const spReferrerId = getParam(urlParams, 'utm_campaign');
    const spReferralSource = getParam(urlParams, 'utm_source');

    if (spReferralSource !== REFERRAL_SOURCE_VALUE || !spReferrerId) {
      return;
    }

    return spReferrerId;
  }

  private static getReferrerIdFromLocalStorage() {
    const lsReferrerId = localStorage.getItem('utm_campaign');
    const lsReferralSource = localStorage.getItem('utm_source');

    if (lsReferralSource !== REFERRAL_SOURCE_VALUE || !lsReferrerId) {
      return;
    }

    return lsReferrerId;
  }

  static getReferrerUniqueId() {
    const referrerUniqueId = this.getReferrerIdFromSearchParams() || this.getReferrerIdFromLocalStorage();

    return referrerUniqueId;
  }

  static updateReferralData() {
    const spReferrerId = this.getReferrerIdFromSearchParams();

    if (spReferrerId) {
      localStorage.setItem('utm_campaign', spReferrerId);
      localStorage.setItem('utm_source', REFERRAL_SOURCE_VALUE);
    }
  }
}
